import {Dayjs} from 'dayjs';

import {ReviewNoteType} from '../../../../service/reviews/reviews-notes';
import {ReviewDataTagType} from '../../../../service/reviews/reviews-type';
import type {ReviewEntityScopeEnum} from '../review-brand-company-scope-card/review-brand-company-scope-card.types';

export {ReviewEntityScopeEnum} from '../review-brand-company-scope-card/review-brand-company-scope-card.types';

export enum ReviewFormFieldNamesEnum {
    id = 'id',
    source = 'source',
    entityScope = 'entityScope',
    brand = 'brand',
    company = 'company',
    createdAt = 'createdAt',
    author = 'author',
    phone = 'phone',
    rating = 'rating',
    content = 'content',
    email = 'email',
    url = 'url',
    attachments = 'attachments',
    tags = 'tag_ids',
    notes = 'notes',
}

export enum ReviewAttachmentTypeEnum {
    image = 'image',
    video = 'video',
}

export type ReviewAttachmentType = {
    id: string;
    type: ReviewAttachmentTypeEnum;
    src: string;
    previewSrc?: string;
};

export type ReviewFormFieldsType = {
    [ReviewFormFieldNamesEnum.id]?: number;
    [ReviewFormFieldNamesEnum.source]: number;
    [ReviewFormFieldNamesEnum.entityScope]?: ReviewEntityScopeEnum;
    [ReviewFormFieldNamesEnum.brand]: number;
    [ReviewFormFieldNamesEnum.company]: string | undefined;
    [ReviewFormFieldNamesEnum.createdAt]: Dayjs;
    [ReviewFormFieldNamesEnum.author]: string | undefined;
    [ReviewFormFieldNamesEnum.phone]: string | undefined;
    [ReviewFormFieldNamesEnum.rating]: number | undefined;
    [ReviewFormFieldNamesEnum.content]: string | undefined;
    [ReviewFormFieldNamesEnum.email]: string | undefined;
    [ReviewFormFieldNamesEnum.url]: string | undefined;
    [ReviewFormFieldNamesEnum.attachments]: Array<ReviewAttachmentType> | undefined;
    [ReviewFormFieldNamesEnum.tags]: Array<ReviewDataTagType> | undefined;
    [ReviewFormFieldNamesEnum.notes]: Array<ReviewNoteType> | undefined;
};
